import { Helmet } from 'react-helmet-async';

/**
 * Schema FAQPage - Données structurées pour les pages FAQ
 * Améliore le référencement et peut afficher les FAQ dans les résultats Google
 * @see https://schema.org/FAQPage
 */
const SchemaFAQPage = ({ faqs }) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaFAQPage;
